import { useQuery } from '@apollo/client/react';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Tooltip } from '@mui/material';

import type { Gec_Events } from '../../gql/graphql';
import { GET_FILTERED_EVENTS } from '../../graphql/queries';
import exportToXLSX from '../../helpers/exportSpreadsheet/exportToXLSX/exportToXLSX';
import useBuildGraphQLVariables from '../../hooks/useBuildGraphQLVariables/useBuildGraphQLVariables';
import useParseEvents from '../../hooks/useParseEvents/useParseEvents';

export const ExportDocButton = () => {
  const filteredData = useBuildGraphQLVariables();
  const { data } = useQuery(GET_FILTERED_EVENTS, {
    variables: { filters: filteredData },
    fetchPolicy: 'cache-only',
  });
  const events = useParseEvents(data?.gec_events as Gec_Events[]);
  const onExportDocClick: () => void = () => {
    events && exportToXLSX('events', events);
  };
  return (
    <Tooltip
      title="Export the current events to an XLSX file"
      arrow
      placement="top"
      sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}
    >
      <Button size="small" variant="text" color="inherit" onClick={onExportDocClick}>
        <DownloadIcon fontSize="small" />
        Export XLSX
      </Button>
    </Tooltip>
  );
};

export default ExportDocButton;
